import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      Login: "Login",
      Email: "El. paštas",
      Password: "Password",
      "Sign up": "Sign up",
      "Login to application": "Login to application",
      company_created_successfully: "Company {{name}} created successfully",
      create_company: "Create company",
      tasks: "Tasks",
      create_task: "Create task",
      update_task: "Update task",
      title: "Title",
      reporter: "Author",
      assigned: "Assigned",
      resolution: "Status",
      due_date: "Due date",
      select_task_from_list: "Select a task from the list",
      resolved: "Resolved",
      is_resolved: "Resolved",
      not_resolved: "Not resolved",
      description: "Description",
      select_user: "Select user",
      log_out: "Log out",
      left: "left",
      search: "Search",
      owner: "Owner",
      assignedTo: "Assigned To",
      user_created_successfully:
        "An email has been sent to your email address containing an activation link. Please click on the link to activate your account. If you do not click the link your account will remain inactive and you will not receive further emails. If you do not receive the email within a few minutes, please check your spam folder.",
      user_created_from_invitation_successfully:
        "You have successfully created account!",
      users: "Users",
      company_settings: "Company settings",
      password_restore: "Restore password",
      signup: "Create new account",
      name: "Name",
      phone: "Phone",
      restore: "Restore",
      restore_page:
        "An email has been sent to your email address containing a restore link.",
      password_restore_email: "Check Your email and click on restore link.",
      create_user: "Create user",
      update_user: "Update user",
      user_status: "Status",
      is_disabled: "Disabled",
      not_disabled: "Active",
      disabled: "Disabled",
      company_name: "Company name",
      company_code: "Company code",
      company_vat: "VAT code",
      company_address: "Address",
      company_description: "Description",
      isDisabled: "Disabled",
      Dashboard: "Dashboard",
      Accounts: "Accounts",
      user_position: "Position",
      customers: "Customer",
      create_customer: "Create customer",
      update_customer: "Update customer",
      save: "Save",
      saved: "Saved",
      not_saved: "Not saved",
      cancel: "Cancel",
      last_edit: "Last Edit",
      make_a_comment: "Make a comment",
      project_details: "Project Details",
      error: "Error",
      field_is_required: "Field is required",
      field_must_be_at_least_characters: "Field must be at least {{minLength}} characters",
      field_must_be_at_least_characters_label: "{{label}} must be at least {{minLength}} characters",
      error_getting_data: "Error getting data",
      vat_code: "VAT code",
      address: "Address",
      valid_to: "Valid until",
      date_picker: "Date picker",
      contact_person: "Contact person",
      orders: "Orders",
      create_order: "Create order",
      expires: "Expires",
      date: "Date",
      number: "Code",
      order_with_provided_number_allready_exist:
        "Order with provided number allready exist",
      customer: "Customer",
      select: "Select",
      unexpected_error: "Unexpected error",
      vats: "Vats",
      create_vat: "Create Vat",
      percent: "Percent",
      products: "Products",
      goods: "Goods",
      create_product: "Create product",
      sku: "Sku",
      unitPrice: "Unit price",
      type: "Type",
      vat: "Vat",
      is_active: "Is active",
      product: "Product",
      service: "Service",
      inactive: "Inactive",
      bills: "Bills",
      invoices: "Invoices",
      requisites: "Requisites",
      create_invoice: "Create invoice",
      serial: "Serial",
      series: "Series",
      series_label: "Series",
      series_create: "Series-create",
      user: "User",
      order: "Order",
      quantity: "Quantity",
      unit_price: "Unit price",
      add_invoice_item: "Add invoice item",
      email_incorrect: "Email not found",
      category_not_found: "Category not found",
      user_exists: "E-mail address already registered",
      add_order_item: "Add order item",
      is_period: "Is period",
      next_invoice_date: "Next order date",
      month: "Month",
      day: "Day",
      total: "Total",
      important: "Important",
      comment: "Comment",
      documents: "Documents",
      category: "Category",
      action: "Action",
      custom_field_code: "Code",
      custom_field_label: "Label",
      custom_field_type: "Type",
      view_account: "View account",
      email_connect: "Email connect",
      status: "Status",
      not_connected: "Not connected",
      connected: "Connected",
      connect: "Connect",
      external: "External",
      internal: "Internal",
      about_company: "About Company",
      the_file_was_uploaded_by: "The file was uploaded by",
      view: "View",
      label: "Label",
      template: "Template",
      files_types_create: "Create",
      files_types: "Files Types",
      "document_is_signed_edit_is_not_allowed": "Document is signed edit is not allowed",
      "select_products": "Select products",
      "generate_order_document": "Generate order document",
      "sign_the_order": "Sign the order",
      "invoice_customer": "Invoice customer",
      "soon": "Soon",
      files_template_custom_min_length: "Minimum character count",
      signontab_select_user: "Select Signontab User",
      manager_should_be_assigned_first: "Manager should be assigned first",
      "assign_zone": "Assign zone",
"release_truck": "Open the barrier and let the truck out",
      "truck_released": "Truck released",
      "not_ready_to_leave": "Accounting has not released this truck yet",
"photo_documents": "Photograph document",
      "photo_documents_unload": "Photograph document",
      "photograph_document": "Photograph document",
      "attached_documents": "Attached documents",
      "document_required": "The transport document is not uploaded yet - the truck cannot be released",
      "document_too_large": "File is too large (over 10 MB)",
      "document_unsupported_type": "Unsupported file type - a photo or a PDF is expected",
      "document_upload_failed": "Upload failed. Try again, or attach the file on the order card",
"zone_unload": "Unloading zone",
      "assign_zone_unload": "Assign zone",
      "invite_unload": "Invite",
      "start_weighing_unload": "Start weighing",
      "ready_to_be_uploaded_unload": "Ready to be unloaded",
      "start_uploading_unload": "Start unloading",
      "finish_uploading__unload": "Finish unloading",
      "finish_uploading_unload": "Finish unloading",
      "start_weighing_again_unload": "Start weighing again",
      "request_documents_unload": "Request documents",
      "ready_to_leave_unload": "Ready to leave",
      "cancel_uploading_unload": "Cancel unloading",
      "direction": "Direction",
      "direction_upload": "Loading",
      "direction_unload": "Unloading",
"enter_document_uploaded_count_unload": "Enter unloaded quantity",
      "invite": "Invite",
      "assign_number": "Assign number",
      "start_weighing": "Start weighing",
      "ready_to_be_uploaded": "Ready to be uploaded",
      "start_uploading": "Start uploading",
      "finish_uploading": "Finish uploading",
      "finish_uploading_": "Finish uploading",
      "start_weighing_again": "Start weighing again",
      "request_documents": "Request documents",
      "ready_to_leave": "Ready to leave",
      "cancel_uploading": "Cancel uploading",
      "sign_rules": "Sign Rules",
      "request_signature": "Request Signature",
      "select_language": "Select Language",
      "rules_signed": "Rules Signed",
      "signed": "Signed",
      "not_signed": "Not Signed",
      "ADR": "ADR",
      "security_control": "Security Control",
      "order_information": "Order Information",
      "terminal_assignment": "Terminal Assignment",
      "terminal_number": "Terminal number",
      "terminal_zone": "Terminal zone",
      "terminal_status": "Terminal status",
      "night_mode_on_guard": "Night mode - you may finish and release trucks",
      "night_mode_until": "Valid until",
      "night_actions_title": "Night mode",
      "night_assign_number_first": "Assign the terminal number to this truck first",
      "night_confirm_step": "Confirm",
      "night_photo_document": "Photograph the waybill",
      "night_document_required": "The truck cannot be released without a photo of the waybill",
      "night_documents_attached": "Documents attached",
      "night_fix_weight": "Record weight",
      "night_scale_pending": "The scale has not shown a weight yet. Wait and try again.",
      "night_places": "Places / pallets",
      "night_zone": "Zone"
    },
  },
  lt: {
    translation: {
      Login: "Prisijungti",
      "Login to application": "Prisijungti prie programos",
      Email: "El. paštas",
      Password: "Slaptažodis",
      "Sign up": "Registracija",
      "Selected company": "Pasirinkta įmonė",
      create_company: "Sukurti įmonę",
      company_created_successfully: "Įmonė sukurta sėkmingai",
      tasks: "Užduotys",
      create_task: "Sukurti užduotį",
      update_task: "Atnaujinti užduotį",
      title: "Pavadinimas",
      reporter: "Sukurė",
      assigned: "Priskirta",
      resolution: "Būsena",
      is_resolved: "Padaryta",
      not_resolved: "Nepadaryta",
      due_date: "Iki kada",
      select_task_from_list: "Pasirinkite užduoti iš sąrašo",
      resolved: "Atlikta",
      description: "Aprašymas",
      select_user: "Pasirinkitę darbuotoją",
      log_out: "Atsijungti",
      left: "liko",
      search: "Paieška",
      owner: "Autorius",
      assignedTo: "Priskirta",
      user_created_successfully:
        "Jūsų el. pašto adresu buvo išsiųstas el. laiškas su aktyvinimo nuoroda. Norėdami suaktyvinti paskyrą, spustelėkite nuorodą. Jei negaunate el. laiško per kelias minutes, patikrinkite savo šlamšto aplanką.",
      user_created_from_invitation_successfully:
        "Jūsų paskyra sėkmingai sukurta!",
      users: "Vartotojai",
      company_settings: "Įmonės nustatymai",
      password_restore: "Slaptažodžio atkūrimas",
      signup: "Sukurti paskyrą",
      name: "Vardas",
      phone: "Telefonas",
      restore: "Atstatyti",
      restore_page:
        "Nurodytu el.paštu buvo išsiųstas el. laiškas su instrukcija",
      password_restore_email:
        "Pasitikrinkite savo pašto dėžutę ir paspauskite pateiktą nuorodą.",
      create_user: "Sukurti vartotoją",
      update_user: "Atnaujinti vartotoją",
      user_status: "Būsena",
      is_disabled: "Išjungtas",
      not_disabled: "Aktyvus",
      disabled: "Išjungtas",
      company_name: "Įmonės/veiklos pavadinimas",
      company_code: "Įm. Kodas",
      company_vat: "PVM kodas",
      company_address: "Adresas",
      company_description: "Aprašymas",
      isDisabled: "Išjungtas",
      Dashboard: "Pradžia",
      Accounts: "Paskyros",
      user_position: "Pareigos",
      customers: "Klientai",
      create_customer: "Sukurti klientą",
      update_customer: "Atnaujinti klientą",
      save: "Išsaugoti",
      saved: "Išsaugota",
      not_saved: "Neišsaugota",
      cancel: "Atšaukti",
      error: "Error",
      field_is_required: "Laukelis yra privalomas",
      error_getting_data: "Duomenis nepasiekiami",
      vat_code: "PVM kodas",
      valid_to: "Galioja iki",
      date_picker: "Kalendorius",
      contact_person: "Kontaktinis asmuo",
      orders: "Sutartys",
      create_order: "Sukurti sutartį",
      expires: "Galioja iki",
      date: "Data",
      number: "Numeris",
      order_with_provided_number_allready_exist:
        "Sutartis su pateiktu numeriu jau egzistuoja",
      select: "Pasirinkimas",
      unexpected_error: "Nutiko klaida",
      vats: "PVM",
      create_vat: "Sukurti PVM",
      percent: "Procentai",
      products: "Produktai",
      create_product: "Sukurti produktą",
      sku: "Kodas",
      unitPrice: "Vieneto kaina",
      type: "Tipas",
      vat: "PVM",
      is_active: "Aktyvus",
      product: "Produktas",
      service: "Paslauga",
      inactive: "Neaktyvus",
      bills: "Sąskaitos",
      invoices: "Sąskaitos",
      requisites: "Rekvizitai",
      create_invoice: "Sukurti sąskaitą",
      serial: "Serija",
      series: "Serija",
      series_label: "Serija",
      series_create: "Sukurti seriją",
      user: "Darbuotojas",
      order: "Sutartis",
      quantity: "Kiekis",
      unit_price: "Vnt. kaina",
      add_invoice_item: "Pridėti prekę",
      email_incorrect: "El. paštas nerastas",
      category_not_found: "kategorija nerasta",
      user_exists: "Nurodytas el.paštas jau yra uzregistruotas.",
      add_order_item: "Pridėti prekę",
      is_period: "Siųsti periodiškai",
      next_invoice_date: "Sekančios sąskaitos data",
      month: "Mėnesis",
      day: "Diena",
      total: "Suma",
      field_company_name_help:
        "Tai gali būti įmonės, veiklos ar kitas pavadinimas.",
      field_company_name: "Veiklos pavadinimas",
      field_password_help: "Minimalus ilgis - 8 simboliai",
      field_email_help_confirm: "Bus išsiųsta patvirtinimo nuoroda",
      form_reg_page_submit_title: "Sukūrti paskyrą",
      menu_item_settings_title: "Nustatymai",
      company_form_is_vat: "PVM mokėtojas",
      company_form_is_vat_help:
        "Bus aktyvuotas funkcionalumas skirtas PVM mokėtojams.",
      login_page_sent_title: "Prisijungimas",
      login_page_sent_text: "Prisijungimo nuoroda buvo issiusta el. pastu",
      files: "Dokumentai",
      file: "Dokumentai",
      customer_details: "Informacija",
      project_details: "Projekto informacija",
      contacts: "Kontaktai",
      edit: "Redaguoti",
      no_contact_person_provided: "Kontaktinis asmuo nenurodytas",
      no_email_address_provided: "El. paštas nenorodytas",
      no_invoice_email_address_provided: "Sąskaitos el. paštas nenurodytas",
      no_secondary_email_address_provided: "Papildomas el. paštas nenurodytas",
      no_phone_number_provided: "Telefonas nenurodytas",
      no_address_provided: "Adresas nenurodytas",
      no_name_provided: "Pavadinimas nenurodytas",
      no_bank_iban_provided: "Banko IBAN nenurodytas",
      no_bank_name_provided: "Banko pavadinimas nenurodytas",
      no_payment_delay_provided: "Mokėjimo atidėjimas nenurodytas",
      no_prepayment_percentage_provided:
        "Išankstinio mokėjimo procentas nenurodytas",
      no_fine_provided: "Bauda nenurodyta",
      bank_details: "Banko duomenys",
      payment_delay: "Mokėjimo atidėjimas",
      prepayment_percentage: "Išankstinio mokėjimo procentas",
      fine: "Bauda",
      no_registration_code_provided: "Įmonės kodas nenurodytas",
      no_vat_code_provided: "PVM kodas nenurodytas",
      valid_email_address_is_required_we_will_send_authentication_link_to_this_email:
        "Į nurodyta el. paštą gausite vienkartinę prisijungimo nuorodą",
      get_auth_link: "Gauti nuorodą",
      max_allowed_debt: "Maksimali skolos suma",
      other: "Kita",
      no_max_allowed_debt_provided: "Maksimali skolos suma nenurodyta",
      assigned_user: "Priskirtas darbuotojas",
      external_code: "Išorinis kodas",
      debt: "Skola",
      no_assigned_person: "Darbuotojas nepriskirtas",
      value: "Reikšmė",
      overdue_debt: "Pradelsta skola",
      payment_due_date: "Sumokėti iki",
      debt_invoices: "Skolos",
      total_quantity: "Kiekis",
      total_amount: "Suma",
      last_invoice_quantity: "PS kiekis",
      last_invoice_amount: "PS suma",
      last_invoice_date: "PS data",
      last_edit: "Redaguota",
      make_a_comment: "Parašyti komentarą",
      invoice_count: "Pirkta kartų",
      turnover: "Apyvarta",
      download: "Parsisiųsti",
      upload: "Įkelti",
      category: "Kategorija",
      file_category_user: "Kategorija",
      file_name: "Pavadinimas",
      no_files: "Kol kas dokumentų nėra",
      customer: "Klientas",
      files_categories: "Dokumentų kategorijos",
      files_categories_subject: "Objektas",
      files_categories_title: "Pavadinimas",
      files_categories_create: "Sukurti kategoriją",
      files_categories_subject_customer: "Klientas",
      files_templates: "Dokumentų šablonai",
      files_templates_title: "Pavadinimas",
      files_templates_category: "Kategorija",
      files_templates_create: "Sukurti šabloną",
      files_build_pdf: "Generuoti dokumentą",
      file_template_select: "Pasirinkti šabloną",
      files_template_custom_name: "Pavadinimas",
      files_template_custom_label: "Žyma šablone",
      files_template_custom_type: "Tipas",
      files_template_custom_add: "Pridėti lauką",
      files_template_custom_remove: "Pašalinti",
      files_template_custom_type_string: "Trumpas tekstas",
      files_template_custom_type_textarea: "Ilgas tekstas",
      files_template_custom_type_date: "Data",
      files_template_custom_remove_option: "Trinti variantą",
      files_template_custom_add_option: "Pridėti variantą",
      files_template_custom_required: "Būtinas laukelis",
      files_template_custom_type_select: "Pasirinkimas",
      files_template_custom_type_select_option: "Variantas",
      files_template_custom_type_select_select_an_option: "Pasirinkite reikšmę",
      files_template_custom_type_products: "Prekės",
      files_template_custom_type_user: "Pasirinkitę darbuotoją",
      files_template_custom_min_length: "Minimalus simbolių skaičius",
      field_must_be_at_least_characters: "Laukelis turi būti bent {{minLength}} simbolių",
      field_must_be_at_least_characters_label: "{{label}} turi būti bent {{minLength}} simbolių",
      manager_should_be_assigned_first: "Pirmiausia turi būti priskirtas vadovas",
      reservations: "Rezervacijos",
      projects: "Projektai",
      "project-boards": "Projektų grupės",
      "project-boards-create": "Sukurti projektų grupę",
      "project-board-name": "Projektų grupės pavadinimas",
      "project-board-column-create": "Sukurti projekto etapą",
      "project-board-column-name": "Etapo pavadinimas",
      "project-board-column-order": "Eiliškumas",
      "project-create": "Sukurti projektą",
      project_column: "Projekto etapas",
      "project-name": "Projekto pavadinimas",
      "project-description": "Projekto aprašymas",
      "project-order": "Prioritetas",
      project_board_column_edit: "Redaguoti",
      customer_select: "Pasirinkti klientą",
      price: "Kaina",
      totalPrice: "Bendra kaina",
      remove: "Pašalinti",
      search_products: "Prekių paieška",
      meta_data: "Meta duomenys",
      product_stock: "Prekės likučiai",
      product_reservations: "Prekės reservacijos",
      warehouse: "Sandėlis",
      customer_form: "Kliento anketa / Customer form",
      "customer_form-general_info": "Bendra informacija / General information",
      "customer_form-name": "Pirkėjo pavadinimas / Customer name",
      "customer_form-name_help": "",
      "customer_form-reg_address":
        "Registracijos adresas / Registration address",
      "customer_form-country": "Šalis / Country",
      "customer_form-country_help": "",
      "customer_form-city": "Miestas / City",
      "customer_form-city_help": "",
      "customer_form-address": "Adresas / Address",
      "customer_form-address_help": "",
      "customer_form-phone": "Telefonas / Phone",
      "customer_form-phone_help": "",
      "customer_form-email": "El. paštas / Email",
      "customer_form-email_help": "",
      "customer_form-vatCode": "PVM kodas / VAT code",
      "customer_form-vatCode_help": "",
      "customer_form-zipCode": "Pašto kodas / Zip code",
      "customer_form-zipCode_help": "",
      "customer_form-office_address":
        "Faktinis (veiklos) adresas / Office address",
      "customer_form-office_address_help":
        "Nurodoma jeigu skiriasi adresas / If different",
      "customer_form-iban": "IBAN sąskatos numeris / IBAN account number",
      "customer_form-iban_help": "",
      "customer_form-iban2": "Kitas ne IBAN numeris / Other than IBAN",
      "customer_form-iban2_placeholder": "",
      "customer_form-iban2_help":
        "pildoma tik tuo atveju, jeigu nėra IBAN / fill only if no IBAN",
      "customer_form-bankName": "Banko pavadinimas / Bank name",
      "customer_form-bankName_help": "",
      "customer_form-companyCode": "Įmonės kodas / Company code",
      "customer_form-companyCode_help": "",
      "customer_form-vatCode2": "Kitas PVM kodas / Other VAT code",
      "customer_form-vatCode2_help": "",
      "customer_form-website": "Interneto svetainė / Website",
      "customer_form-website_help": "",
      "customer_form-swiftCode": "SWIFT kodas / SWIFT code",
      "customer_form-swiftCode_help": "",
      important: "Svarbu",
      comment: "Komentaras",
      "customer_form-error_heading":
        "Anketos nuoroda negaliojanti / Form link is invalid",
      "customer_form-error_message":
        "Prašome susisiekti su vadybininku / Please contact your manager",
      "customer_form-contacts": "Kontaktiniai duomenys / Contact details",
      "customer_form-contact_fullName":
        "Kontaktinis asmuo (vardas, pavardė) / Contact person (full name)",
      "customer_form-contact_fullName_help": "",
      "customer_form-contact_position": "Pareigos / Position",
      "customer_form-contact_position_help": "",
      "customer_form-contact_phone_help": "",
      "customer_form-contact_email_help": "",
      "customer_form-contact_phone": "Telefonas / Phone",
      "customer_form-contact_email": "El. paštas / Email",
      "customer_form-other_details": "Kita informacija / Other details",
      "customer_form-invoice_email":
        "El. paštas sąskaitų siuntimui / Invoice email",
      "customer_form-invoice_email_help": "",
      "customer_form-signature_details":
        "Vadovo arba asmens kuris pasirašys sutartį duomenys / Data of the person who will sign the contract",
      "customer_form-signature_fullName": "Vardas, pavardė / Full name",
      "customer_form-signature_fullName_help": "",
      "customer_form-signature_position": "Pareigos / Position",
      "customer_form-signature_position_help": "",
      "customer_form-signature_email":
        "El. paštas sutarties pasirašymui / Email for signing the contract",
      "customer_form-signature_email_help": "",
      "customer_form-signature_basis_of_representation":
        "Atstovavimo pagrindas",
      "customer_form-signature_basis_of_representation_help":
        "Nurodyti įstatus arba kitą pagrindą. Jei pasirašys ne įmonės vadovas - pateikti atstovavimo pagrindą pagrindžiantį dokumentą / Specify the status or other basis. If the contract is signed by a person other than the company's manager - provide a document justifying the basis of representation",
      "customer_form-payments":
        "Atsakingas už mokėjimus / Responsible for payments",
      "customer_form-payments_fullName": "Vardas, pavardė / Full name",
      "customer_form-payments_fullName_help": "",
      "customer_form-payments_position": "Pareigos / Position",
      "customer_form-payments_position_help": "",
      "customer_form-payments_email": "El. paštas / Email",
      "customer_form-payments_email_help": "",
      "customer_form-payments_phone": "Telefonas / Phone",
      "customer_form-payments_phone_help": "",
      "customer_form-signer-positionAndFullName":
        "Pareigos, vardas, pavardė / Position, full name",
      "customer_form-sign": "Pasirašyti ir siųsti / Sign and send",
      "customer_form-name_required":
        "Prašome įvesti pavadinimą / Please enter the name",
      "customer_form-companyCode_required":
        "Prašome įvesti įmonės kodą / Please enter the company code",
      "customer_form-phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-email_required":
        "Prašome įvesti el. pašto adresą / Please enter the email address",
      "customer_form-address_required":
        "Prašome įvesti adresą / Please enter the address",
      "customer_form-city_required":
        "Prašome įvesti miestą / Please enter the city",
      "customer_form-country_required":
        "Prašome pasirinkti šalį / Please select the country",
      "customer_form-zipCode_required":
        "Prašome įvesti pašto kodą / Please enter the zip code",
      "customer_form-bankName_required":
        "Prašome įvesti banko pavadinimą / Please enter the bank name",
      "customer_form-iban_required":
        "Prašome įvesti IBAN kodą / Please enter the IBAN code",
      "customer_form-contact_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-contact_phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-contact_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-contact_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signature_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-signature_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-signature_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signature_basis_of_representation_required":
        "Prašome įvesti atstovavimo pagrindą / Please enter the basis of representation",
      "customer_form-invoice_email_required":
        "Prašome įvesti sąskaitų faktūrų el. paštą / Please enter the invoice email",
      "customer_form-payments_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-payments_phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-payments_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-payments_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signer_fullName_required":
        "Prašome įvesti pasirašančio asmens vardą ir pavardę / Please enter the full name of the signing person",
      "customer_form-zipCode_figures_required": "Skaičiai privalomas/ Figures required",
      "customer_form-zipCode_letters_required": "Raidės privalomas/ Letters required",
      "customer_form-submit_error":
        "Prašome ištaisyti anketos klaidas / Please correct the form errors",
      "customer_form-success_heading":
        "Anketa sėkmingai pateikta / Form submitted successfully",
      "customer_form-success_text":
        "Netrukus su Jumis susisieksime / We will contact you soon",
      documents: "Dokumentai",
      action: "Veiksmas",
      customer_questionnaire: "Kliento anketa",
      "customer_form-different_contact_person":
        "Kontaktinis asmuo skiriasi, nurodyti kontaktinį asmenį / Contact person is different, specify the contact person",
      "customer_form-different_payments_person":
        "Už apmokėjimus atsakingas kitas asmuo, nurodyti kontaktinį asmenį / Another person is responsible for payments, specify the contact person",
      "customer_questionnaire-generated":
        "Kliento anketa sugeneruota ir išsiusta:",
      "customer_questionnaire-signed":
        "Kliento anketa pateikta ir pasirašyta: / Customer form submitted and signed:",
      "customer_form-documents": "Dokumentai / Documents",
      "customer_form-delete_confirmation":
        "Ar tikrai norite ištrinti dokumentą? / Are you sure you want to delete the document?",
      "customer_form-delete": "Ištrinti / Delete",
      "customer_questionnaire-not_signed": "Kliento anketa nepasirašyta",
      add: "Pridėti",
      files_category_title: "Kategorijos pavadinimas",
      createdAt: "Sukūrimo data",
      updatedAt: "Atnaujinta",
      contact_add: "Pridėti kontaktinį asmenį",
      "contact-name": "Vardas Pavardė",
      position: "Pareigos",
      email: "El. paštas",
      "is-authorized-to-sign": "Įgaliotas pasirašyti sutartį",
      "customer_questionnaire-generate": "Generuoti ir siųsti kliento anketą",
      custom_field_code: "Kodas",
      custom_field_label: "Pavadinimas",
      custom_field_type: "Tipas",
      custom_fields: "Papildomi laukeliai",
      custom_field_create: "Sukurti papildomą laukelį",
      view_account: "Peržiūrėti paskyrą",
      email_connect: "El. paštas prijungimas",
      status: "Būsena",
      not_connected: "Ne prijungta",
      connected: "Prijungta",
      connect: "Prijungti",
      external: "Išorinė",
      internal: "Vidinė",
      about_company: "Apie įmonę",
      select_series: "Pasirinkite seriją",
      externalNumber: "Įšorinis numeris",
      document_date: "Dokumento data",
      select_existing_customer: "Pasirinkti esamą klientą",
      save_customer: "Įšsaugoti klientą",
      customer_name: "Kliento pavadinimas",
      category_order: "Eiliškumas",
      email_messages: "El. paštas",
      legal_name: "Teisinis pavadinimas",
      is_shared_category: "Visoms įmonėms matoma kategorija",
      customer_search: "Klientų paieška",
      responsible_user: "Atsakingas darbuotojas",
      is_required: "Būtinas laukelis",
      is_visible_in_list: "Matomas sąraše",
      text: "Tekstas",
      checkbox: "Varnelė",
      custom_field_object: "Laukelio objektas",
      settings: "Nustatymai",
      the_file_was_uploaded_by: "Failą įkėlė",
      select_field: "pasirinkti lauką",
      add_Field: "pridėti lauką",
      save_field: "išsaugoti lauką",
      ok: "gerai",
      financials: "Finansai",
      invoice: "sąskaita faktūra",
      no_sku_provided: "SKU nenurodytas",
      no_description_provided: "aprašymas nenurodytas",
      notes: "pastabos",
      no_legal_name_provided: "juridinis pavadinimas nenurodytas",
      no_vat_provided: "PVM kodas nenurodytas",
      no_code_provided: "kodas nenurodytas",
      custom_type_select_option: "pasirinkimo opcija",
      custom_remove_option: "pašalinti pasirinkimą",
      custom_add_option: "pridėti pasirinkimą",
      finvalda: "finvalda",
      assignedUser: "priskirtas darbuotojas",
      no_categories: "kategorijų nėra",
      document_name: "dokumento pavadinimas",
      file_name_is_required: "būtinas nurodyti failo pavadinimą",
      category_is_required: "būtina nurodyti kategoriją",
      user_is_required: "būtina nurodyti darbuotoją",
      customer_is_required: "būtina nurodyti klientą",
      files_template_name: "šablono pavadinimas",
      files_template_serial: "šablono serija",
      files_template_html: "šablono HTML",
      reserved: "rezervuota",
      client_id: "kliento ID",
      tenant_id: "tenant ID",
      secret: "slaptas raktas",
      finvaldaUser: "finvalda vartotojas",
      finvaldaPass: "finvalda slaptažodis",
      finvaldaAddress: "finvalda adresas",
      finvaldaCompanyId: "finvalda įmonės ID",
      no_external_code_provided: "nėra išorinio kodo",
      disconnect: "atsijungti",
      invoice_id: "sąskaitos ID",
      invoice_serial: "sąskaitos serija",
      invoice_number: "sąskaitos numeris",
      invoice_date: "sąskaitos data",
      invoice_user: "sąskaitos naudotojas",
      invoice_order: "sąskaitos užsakymas",
      bank_iban: "banko IBAN",
      bank_name: "banko pavadinimas",
      next_order_date: "kito užsakymo data",
      "Select assigned user": "Priskirtas darbuotojas",
      view: "Peržiūrėti",
      label: "Pavadinimas",
      template: "Šablonas",
      files_types_create: "Sukurti",
      files_types: "Dokumentų tipai",
      files_types_select: "Pasirinkite dokumento tipą",
      enter_file_context: "Įveskite objektą/kontekstą",
      groups_management: "Grupių valdymas",
      permissions: "Teisės",
      create: "Sukurti",
      permissions_select: "Teisių pasirinkimas",
      user_group: "Priskirta grupė",
      manager: "Vadovas",
      totalWithVat: "Suma su PVM",
      totalWithoutVat: "Suma be PVM",
      turnoverWithoutVat: "Apyvarta be PVM",
      debtWithVat: "Skola su PVM",
      sales_returns: "Grąžinimai",
      is_approval_required: "Reikalingas vadovo patvirtinimas",
      approval_required: "Reikalingas vadovo patvirtinimas",
      Are_you_sure_you_want_to_generate_questionnaire:
        "Ar tikrai norite generuoti ir siųsti anketą klientui?",
      save_and_approve: "Išsaugoti ir patvirtinti",
      Yes: "Taip",
      No: "Ne",
      approval_request: "Patvirtinti klientą",
      Are_you_sure_you_want_to_approve_customer:
        "Ar tikrai norite patvirtinti klientą",
      "customer_form-signer-position": "Pareigos / Position",
      "customer_form-signer-firstName": "Vardas / First name",
      "customer_form-signer-lastName": "Pavardė / Last name",
      "customer_form-signer-signerFullName": "Vardas, pavardė/ First and last name",
      "customer_form-signer_position_required":
        "Būtina nurodyti pareigas / Position is required",
      "customer_form-signer_firstName_required":
        "Būtina nurodyti vardą / First name is required",
      "customer_form-signer_lastName_required":
        "Būtina nurodyti pavardę / Last name is required",
      "customer_form-invoice_valid_email_required":
        "Būtinas galiojantis el. pašto adresas / Valid email is required",
      advance_invoice_deferral_days: "Avansinės sąskaitos atidėjimo dienos",
      invoice_deferral_days: "Sąskaitos atidėjimas, dienos",
      advance_payment_percent: "Avanso mokėjimo procentas",
      debt_limit: "Skolos limitas, Eur",
      penalty_percent: "Baudos procentas",
      storage_costs_per_unit: "Sandėliavimo išlaidos už vienetą",
      non_performance_percent: "Neįvykdymo procentas",
      dateTo: "Iki datos",
      Are_you_sure_you_want_to_send_document_signature_request:
        "Ar tikrai norite išsiųsti dokumento pasirašymo užklausą?",
      Are_you_sure_you_want_to_generate_and_send_finance_file_for_customer_sign:
        "Ar tikrai norite sugeneruoti ir išsiųsti pagrindinę sutartį?",
      generate_form_and_send_for_customer:
        "Sugeneruoti formą ir išsiųsti klientui",
      Finance: "Finansai",
      signed: "Pasirašyta",
      document_signature: "Dokumento pasirašymas",
      select_contact: "Pasirinkti kliento kontaktą",
      document_send_signature_request: "Siųsti pasirašymo prašymą",
      document_status: "Dokumento būsena",
      sign_status: "Pasirašymo būsena",
      contact_signer: "Kliento kontaktas",
      selected_user: "Pasirinktas darbuotojas",
      customer_contact: "Kliento kontaktas",
      select_assigned_user: "Pasirinkite priskirtą darbuotoją",
      is_valid_financial_approval_required:
        "Reikalingas finansinis patvirtinimas",
      signature_pending: "Laukiama parašo",
      finance_activated: "Pasirašyta",
      master_agreement: "Pagrindinė sutartis",
      master_agreement_description:
        "Pagrindinė sutartis yra dokumentas, kuriame nustatomos bendrosios sąlygos, taisyklės ir įsipareigojimai, taikomi šalims, sudarant tarpusavio sandorius.",
      master_agreement_approved: "Patvirtinta",
      master_agreement_not_approved: "Nepatvirtinta",
      Are_you_sure_you_want_to_request_to_sign_file:
        "Ar tikrai norite pateikti prašymą pasirašyti failą",
      no_manager_provided: "Vadovas nenurodytas",
      invalid_email_address: "Neteisingas el.paštas",
      sign_type: "Pasirašymo tipas",
      manual_sign: "Rankinis pasirašymas",
      upload_signed_document: "Įkelti pasirašytą dokumentą",
      sign_request: "Pasirašymo prašymas",
      select_signers: "Pasirinkite kas pasirašys",
      select_sign_permission_user: "Pasirinkite vadovą",
      select_contact_user: "Pasirinkite kontaktinį asmenį",
      contact_user: "Pardavėjo kontaktinis asmuo",
      sign_permission_user: "Pardavėjas",
      pending: "Laukiama",
      addresses: "Adresai",
      address_add: "Sukurti adresą",
      address: "Pilnas adresas",
      address_name: "Trumpas adreso pavadinimas",
      files_template_custom_type_address: "Adresas",
      enable_category_tree_rule: "Įjungti kategorijų medžio taisykles",
      is_user_technical: "Techninis vartotojas",
      permission_group: "Teisių grupė",
      select_manager: "Pasirinkite vadovą",
      company_phone: "Darbinis telefonas",
      select_address: "Pasirinkite adresą",
      address_type: "Adreso tipas",
      company: "Įmonė",
      category_permission: "Kategorijų teisės",
      customer_permission: "Klientų teisės",
      cancel_form: "Atšaukti",
      Are_you_sure_you_want_to_cancel_questionnaire:
        "Ar tikrai norite atšaukti anketą?",
      email_to: "Gavėjas",
      email_subject: "Tema",
      email_resend: "Persiųsti",
      duplicate_signer_selected_choose_a_different_user: "Pasikartojantis pasirašytojas pasirinktas. Pasirinkite kitą vartotoją",
      selected_user_is_required: "Pasirinktas vartotojas yra privalomas",
      sign_type_is_required: "Pasirašymo tipas yra privalomas",
      contact_signer_is_required: "Kontaktinis pasirašantysis yra privalomas",
      date_is_required: "Data yra privaloma",
      template_is_required: "Šablonas yra privalomas",
      send_email: "Siųsti el. laišką",
      file_type_is_required: "Failo tipas yra privalomas",
      Are_you_sure_you_want_to_send_document_to_customer_by_email:
        "Ar tikrai norite išsiųsti dokumentą klientui el. paštu?",
      documents_signature_request: "Dokumento pasirašymo prašymas",
      Are_you_sure_you_want_to_cancel_signature_request:
        "Ar tikrai norite atšaukti pasirašymo prašymą?",
      cancel_sign_request: "Atšaukti pasirašymo prašymą",
      is_visible_in_profile: "Matomas asmeniniame kabinete",
      are_you_sure_you_want_to_sign_the_file:
        "Ar tikrai norite pasirašyti dokumentą?",
      sign: "Pasirašyti",
      are_you_sure_you_want_to_decline_document_signature_request:
        "Ar jūs tikrai norite atmesti dokumento pasirašymo užklausą",
      decline: "Atmesti",
      declined: "Atmesta",
      sign_request_to_manager: "Pasirašymo užklausa vadovui",
      manager_is_not_assigned_to_the_user: "Vartotojui nepriskirtas vadovas",
      "customer_form-signature_valid_email_required":
        "Būtinas galiojantis el. pašto adresas / Valid email is required",
      emails: "El. laiškai",
      resend: "Persiųsti el. laišką",
      is_user_private: "Įgaliotas asmuo",
      assets: "Materialinės vertybės",
      asset_name: "Pavadinimas",
      asset_type: "Tipas",
      asset_brand: "Gamintojas",
      asset_model: "Modelis",
      asset_serial: "Unikalus numeris",
      asset_in_use: "Naudojamas",
      asset_in_stock: "Sandėlyje",
      asset_broken: "Sugadintas",
      asset_purchase_date: "Įsigijimo data",
      asset_assign_user: "Priskirti darbuotoją",
      asset_assigned_to: "Priskirtas darbuotojas",
      asset_create: "Sukurti materialinę vertybę",
      asset_notes: "Pastabos",
      previous_assigned_user: "Prieš tai priskirtas darbuotojas",
      asset_assigned_user: "Priskirtas darbuotojas",
      assigned_date: "Priskyrimo data",
      asset_assigned_tracks: "Naudojimosi istorija",
      asset_status: "Turto statusas",
      checksum_files: "Rastos dokumento kopijos",
      pending_signatures: "Laukiančios parašų",
      no_pending_signatures: "Nėra laukiančių parašų",
      notification: "Pranešimas",
      asset_type_is_required: "Turto tipas yra privalomas",
      assets_types_select: "Pasirinkite turto tipą",
      title_is_required: "Pavadinimas yra privalomas",
      assets_types_create: "Sukurti turto tipą",
      notify_accountancy: "Pranešti buhalterijai",
      accountancy_user: "Buhalterijos vartotojas",
      select_accountancy_user: "Pasirinkti buhalterijos vartotoją",
      email_sent_successfully: "El. laiškas sėkmingai išsiųstas",
      child_files: "Vaikiniai failai",
      navigate_to_document_module: "Dokumento peržiūra",
      no_files_to_review: "Nėra failų peržiūrai",
      my_work: "Mano darbai",
      pending_files: "Dokumentas peržiūrai",
      pending_signature: "Dokumentas pasirašymui",
      are_you_sure_you_want_mark_as_reviewed: "Ar tikrai norite pažymėti kaip peržiūrėtą?",
      to_review: "Peržiūrai",
      edit_sign_request: "Redaguoti pasirašymo užklausą",
      mark_as_reviewed: "Pažymėti kaip peržiurėtą",
      signature: "pasirašyti",
      review_by: "Peržiūrėjo",
      reviewed: "Peržiūrėta",
      no_review_required: "Peržiūra_nereikalinga",
      review_required_by: "Siųsti peržiūrai",
      OrderForm: "Užsakymo forma",
      search_files: "Dokumentų paieška",
      customer_hide: "Paslėpti klientus",
      is_hide: "Paslėptas",
      required_within_days: "Dokumentai įkeliami per",
      finance_document_should_be_sign: "Finansinis dokumentas turi būti pasirašytas.",
      not_initiate: "Neinicijuota",
      "document_is_signed_edit_is_not_allowed": "Dokumentas pasirašytas – redaguoti neleidžiama",
      "select_products": "Pasirinkti prekes",
      "generate_order_document": "Sugeneruoti užsakymo dokumentą",
      "sign_the_order": "Pasirašyti užsakymą",
      "invoice_customer": "Išrašyti sąskaitą",
      "soon": "Jau greitai ;)",
      "product_name": "Pavadinimas",
      no_documents_found: "Dokumentų nerasta",
      internal_order_number: "Numeris",
      "are_you_sure_you_want_in_stock_asset": "Ar tikrai norite grąžinti materialinės į sandėlį",
      "assign_asset": "Priskirti",
      "signature_status": "Pasirašymo būsena",
      "assignation_info": "Priskyrimo informacija",
      "not_assigned": "Ne priskirta",
      "the_asset_will_be_assigned_once_the_document_is_signed": "Materialinės bus priskirtas, kai dokumentas bus pasirašytas",
      "return_asset": "Grąžinti",
      "edit_asset": "Koreguoti",
      "return_info": "Grąžinti informaciją",
      "not_returned": "Negrąžinta",
      "terminal_delivery": "Terminalo Pristatymas",
      "customer_form-name_too_long": "Pavadinimas per ilgas(maks. 255 simboliai) / Name is too long(max. 255 characters)",
      "customer_form-companyCode_too_long": "Įmonės kodas per ilgas(maks. 250 simbolių) / Company code is too long(max. 250 characters)",
      "customer_form-phone_too_long": "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-email_too_long": "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-address_too_long": "Adresas per ilgas(maks. 255 simboliai) / Address is too long(max. 255 characters)",
      "customer_form-bankName_too_long": "Banko pavadinimas per ilgas(maks. 100 simbolių) / Bank name is too long(max. 100 characters)",
      "customer_form-iban_too_long": "IBAN per ilgas(maks. 100 simbolių) / IBAN is too long(max. 100 characters)",
      "customer_form-signatureFullName_too_long": "Pavadinimas per ilgas(maks. 100 simbolių) / Name is too long(max. 100 characters)",
      "customer_form-signaturePosition_too_long": "Pareigos per ilgos(maks. 100 simbolių) / Position is too long(max. 100 characters)",
      "customer_form-signatureEmail_too_long": "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-contactFullName_too_long": "Pavadinimas per ilgas(maks. 50 simbolių) / Name is too long(max. 50 characters)",
      "customer_form-contactPhone_too_long": "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-contactPosition_too_long": "Pareigos per ilgos(maks. 255 simboliai) / Position is too long(max. 255 characters)",
      "customer_form-contactEmail_too_long": "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-paymentsFullName_too_long": "Pavadinimas per ilgas(maks. 50 simbolių) / Name is too long(max. 50 characters)",
      "customer_form-paymentsPhone_too_long": "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-paymentsPosition_too_long": "Pareigos per ilgos(maks. 255 simboliai) / Position is too long(max. 255 characters)",
      "customer_form-paymentsEmail_too_long": "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-iban2_too_long": "IBAN2 per ilgas(maks. 100 simbolių) / IBAN2 is too long(max. 100 characters)",
      "customer_form-vatCode_too_long": "PVM kodas per ilgas(maks. 100 simbolių) / VAT code is too long(max. 100 characters)",
      "customer_form-website_too_long": "Interneto svetainės adresas per ilgas(maks. 255 simboliai) / Website address is too long(max. 255 characters)",
      "customer_form-officeAddress_too_long": "adresas per ilgas(maks. 255 simboliai) / Address is too long(max. 255 characters)",
      "customer_form-swiftCode_too_long": "SWIFT kodas per ilgas(maks. 100 simbolių) / SWIFT code is too long(max. 100 characters)",
      "customer_form-valid_iban2_required": "Būtinas laukelis / This field is required",
      "operation not allowed: asset is currently assigned": "Operacija neleidžiama: turtas šiuo metu yra priskirtas.",
      "acceptance_transfer_act": "Priėmimo-perdavimo aktas",
      "select_the_user": "Pasirinkti darbuotoją",
      "related_files": "Susiję failai",
      "document_permit_settings": "Dokumento leidimo nustatymai",
      "email_must_be_correct": "El. paštas turi būti teisingas",
      "create_company_form": "Sukurti įmonę",
      "asset_force_return": "Grąžinti priverstinai",
      "show_more": "Rodyti daugiau",
      "select_signature_types": "Pasirinkite parašų tipus",
      "upload_fuel_report": "Įkelti ataskaitą",
      "create_fuel_report": "Pildyti ataskaitą",
      "edit_fuel_report": "Atnaujinti kuro ataskaitą",
      "generate_fuel_report": "Sugeneruoti kuro dokumentą",
      "sign_the_fuel_report": "Pasirašyti kuro dokumentą",
      "fuel_consumption": "Sunaudota kuro (ltr)",
      "mileage": "Nuvažiuota rida (km)",
      "ev_charge_kw": "EV įkrovos kWh",
      "amount": "Suma (EUR)",
      "fuel_records": "Kuro įrašai",
      "fuel_reports": "Kuro ataskaitos",
      "asset": "Materialinės vertybės",
      "fuel_card": "Kuro kortelė",
      "end_of_month_km": "Mėnesio pabaigos rida (km)",
      "end_of_month_ltr": "Mėnesio pabaigos kuras (ltr)",
      "asset_select": "Pasirinkite turtą",
      "year_month_select": "Metai/Mėnuo",
      "asset_select_car": "Pasirinkite automobilį",
      "fuel_card_select": "Pasirinkite kuro kortelę",
      "asset_is_required": "Materialinės vertybės yra privalomas",
      "fuel_card_is_required": "Kuro kortelė yra privaloma",
      "end_of_month_km_required": "Mėnesio pabaigos rida yra privaloma",
      "end_of_month_ltr_required": "Mėnesio pabaigos kuras yra privalomas",
      "start_of_month_km": "Mėnesio pradžiai (km)",
      "start_of_month_ltr": "Mėnesio pradžiai (ltr)",
      "start_of_month_km_required": "Mėnesio pradžios km yra privalomas",
      "start_of_month_ltr_required": "Mėnesio pradžios ltr yra privalomas",
      "end_km_must_be_greater_than_start": "Mėnesio pabaigos km turi būti didesnis nei pradžios",
      "card_user": "Kortelės naudotojas",
      "card_no": "Kortelės numeris",
      "place": "Vieta",
      "receipt_number": "Kvito numeris",
      "fuel_type": "Kuro tipas",
      "is_fuel_details_required": "Reikalinga degalų informacija",
      "fuel_consumption_per_month_ltr": "Sunaudota kuro per mėnesį (ltr)",
      "mileage_per_month_km": "Rida per mėnesį (km)",
      "winter_period_fuel_rate": "Žiemos laikotarpio kuro norma(lapkričio-kovo mėnesiai)",
      "summer_period_fuel_rate": "Vasaros laikotarpio kuro norma(balandžio-spalio mėnesiai)",
      "work_purpose_km_required": "Nuvažiuota darbo laiku yra privaloma",
      "work_purpose_km": "Nuvažiuota darbo laiku",
      "ev_charge_amount": "Suma (EUR)",
      "add_more_signers": "Pridėti parašų",
      "Are_you_sure_you_want_add_signers": "Ar tikrai norite pridėti parašus",
      invoice: "sąskaita",
      grounds_for_representation: "Atstovavimo pagrindas",
      invoice_email: "El. paštas sąskaitų siuntimui",
      secondary_email: "Papildomas el. paštas",
      reason_for_decline_signature: "Atsisakymo priežastis",
      please_provide_a_reason_for_declining_the_signature_request: "Prašome nurodyti atsisakymo priežastį",
      show_limited: "Rodyti ribotus klientus",
      show_all_customers: "Rodyti visus klientus",
      "SignOnTab-Connect": "Signontab-Prisijungti",
      "signontab_domain": "domenas",
      "signontab_client_id": "kliento ID",
      "signontab_client_secret": "slaptas raktas",
      "signontab_select_tablet_user": "Pasirinkite Signontab vartotoją",
      username: "Vartotojo vardas",
      password: "Slaptažodis",
      requiredFields: "Prašome užpildyti visus privalomus laukus.",
      "signontab_users": "Signontab vartotojai",
      "signontab_user_create": "Sukurti Signontab vartotoją",
      "order_number": "Užsakymo numeris",
      "transport_company": "Transporto įmonė",
      "truck_plate_number": "Sunkvežimio valstybinis numeris",
      "driver_name": "Vairuotojo vardas",
      "goods": "Prekės",
      "terminal_number": "Terminalo numeris",
      "zone": "Zona",
      "enter_terminal_number": "Įveskite terminalo numerį",
      "please_try_again": "Bandykite dar kartą",
      "no_date_provided": "Data nepateikta",
      "no_order_provided": "Užsakymas nepateiktas",
      "no_transport_company_provided": "Transporto įmonė nepateikta",
      "no_truck_plate_number_provided": "Sunkvežimio valstybinis numeris nepateiktas",
      "no_driver_name_provided": "Vairuotojo vardas nepateiktas",
      "no_terminal_number_provided": "Terminalo numeris nepateiktas",
      "auto": "Automatinis",
      "assign_zone": "Priskirti zona",
"release_truck": "Išleisti automobilį pro vartus",
      "truck_released": "Automobilis išleistas",
      "not_ready_to_leave": "Apskaita dar neišleido automobilio",
"photo_documents": "Nufotografuoti dokumentą",
      "photo_documents_unload": "Nufotografuoti dokumentą",
      "photograph_document": "Fotografuoti dokumentą",
      "attached_documents": "Prisegti dokumentai",
      "document_required": "Transporto dokumentas dar neįkeltas – automobilio išleisti negalima",
      "document_too_large": "Failas per didelis (daugiau nei 10 MB)",
      "document_unsupported_type": "Netinkamas failo tipas – tinka nuotrauka arba PDF",
      "document_upload_failed": "Nepavyko įkelti. Bandykite dar kartą arba prisekite failą užsakymo kortelėje",
      "confirm": "Patvirtinti",
      "saved": "Išsaugota",
"zone_unload": "Iškrovimo zona",
      "assign_zone_unload": "Priskirti zoną",
      "invite_unload": "Kviesti automobilį",
      "start_weighing_unload": "Pradėti svėrimą",
      "ready_to_be_uploaded_unload": "Galima iškrauti",
      "start_uploading_unload": "Pradėti iškrovimą",
      "finish_uploading__unload": "Baigti iškrovimą",
      "finish_uploading_unload": "Baigti iškrovimą",
      "start_weighing_again_unload": "Pradėti svėrimą",
      "request_documents_unload": "Kviesti pasirašyti dokumentus",
      "ready_to_leave_unload": "Išleisti automobilį",
      "cancel_uploading_unload": "Atšaukti iškrovimą",
      "enter_zone_unload": "Įveskite iškrovimo zoną",
      "select_zone_unload": "Pasirinkti iškrovimo zoną",
      "enter_document_uploaded_count_unload": "Įveskite iškrautą kiekį",
      "loaded_quantity_unload": "Iškrautas kiekis",
      "direction": "Kryptis",
      "direction_upload": "Pakrovimas",
      "direction_unload": "Iškrovimas",
      "invite": "Kviesti automobilį",
      "assign_number": "Priskirti numerį",
      "start_weighing": "Pradėti svėrimą",
      "ready_to_be_uploaded": "Galima pakrauti",
      "start_uploading": "Pradėti pakrovimą",
      "finish_uploading": "Baigti pakrovimą",
      "finish_uploading_": "Baigti pakrovimą",
      "start_weighing_again": "Pradėti svėrimą",
      "request_documents": "Kviesti pasirašyti dokumentus",
      "ready_to_leave": "Išleisti automobilį",
      "cancel_uploading": "Atšaukti pakrovimą",
      "security_control": "Apsaugos kontrolė",
      "assigned_user":"Priskirtas darbuotojas",
      "loaded_quantity":"Pakrautas kiekis",
      "sign_rules": "Pasirašyti taisykles",
      "request_signature": "Prašyti parašo",
      "select_language": "Pasirinkite kalbą",
      "rules_signed": "Taisyklės pasirašytos",
      "signed": "Pasirašyta",
      "not_signed": "Nepasirašyta",
      "ADR": "ADR",
      "order_information": "Užsakymo informacija",
      "terminal_assignment": "Terminalo priskyrimas",
      "terminal_number": "Terminalo numeris",
      "terminal_zone": "Pakrovimo zona",
      "terminal_status": "Terminalo būsena",
      "sent": "išsiųsta",
      "night_mode_on_guard": "Naktinis režimas — galite užbaigti ir išleisti mašinas",
      "night_mode_until": "Galioja iki",
      "night_actions_title": "Naktinis režimas",
      "night_assign_number_first": "Pirma priskirkite mašinai eilės numerį",
      "night_confirm_step": "Atlikti",
      "night_photo_document": "Fotografuoti važtaraštį",
      "night_document_required": "Be važtaraščio nuotraukos mašina neišleidžiama",
      "night_documents_attached": "Prisegta dokumentų",
      "night_fix_weight": "Fiksuoti svorį",
      "night_scale_pending": "Svarstyklės dar neparodė svorio. Palaukite ir bandykite dar kartą.",
      "night_places": "Vietos / padėklai",
      "night_zone": "Zona"
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "lt", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
